import { SearchTerm } from './SearchTerm';

const TagSearch: SearchTerm[] = [
    {
        heading: "Type",
        accessor: "type",
        searchOnName: "credType",
        translationKey: "type"
    },
    {
        heading: "Code",
        accessor: "code",
        searchOnName: "credCode",
        translationKey: "code"
    },
    {
        heading: "Description",
        accessor: "description",
        searchOnName: "credDesc",
        translationKey: "description"
    },
    {
        heading: "Status",
        accessor: "status",
        searchOnName: "credStatus",
        translationKey: "status"
    }
];

export default TagSearch;
